import React from "react";

const ArrowRightBlue16 = ({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    {...props}
  >
    <path
      d="M13.8538 8.35372L9.35375 12.8537C9.25993 12.9475 9.13268 13.0003 9 13.0003C8.86732 13.0003 8.74007 12.9475 8.64625 12.8537C8.55243 12.7599 8.49972 12.6327 8.49972 12.5C8.49972 12.3673 8.55243 12.24 8.64625 12.1462L12.2931 8.49997H2.5C2.36739 8.49997 2.24021 8.44729 2.14645 8.35353C2.05268 8.25976 2 8.13258 2 7.99997C2 7.86736 2.05268 7.74019 2.14645 7.64642C2.24021 7.55265 2.36739 7.49997 2.5 7.49997H12.2931L8.64625 3.85372C8.55243 3.7599 8.49972 3.63265 8.49972 3.49997C8.49972 3.36729 8.55243 3.24004 8.64625 3.14622C8.74007 3.0524 8.86732 2.99969 9 2.99969C9.13268 2.99969 9.25993 3.0524 9.35375 3.14622L13.8538 7.64622C13.9002 7.69266 13.9371 7.7478 13.9623 7.8085C13.9874 7.8692 14.0004 7.93427 14.0004 7.99997C14.0004 8.06568 13.9874 8.13074 13.9623 8.19144C13.9371 8.25214 13.9002 8.30729 13.8538 8.35372Z"
      fill="#4C70EF"
    />
  </svg>
);

export default ArrowRightBlue16;
